module.exports = __webpack_public_path__ + "media/images/gobble_july4th/bg-sm-4fdfc5b0870d27d0c96bc310d7d39e9d.jpg";